import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  style: {"width":"100%"},
  class: "px-7"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_select_filled = _resolveComponent("v-select-filled")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_CompaniesTable = _resolveComponent("CompaniesTable")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_snackbar = _resolveComponent("v-snackbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, {
      "no-gutters": "",
      style: {"flex-wrap":"nowrap"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { class: "display-1 flex-grow-1 flex-shrink-0 text-h4" }, {
          default: _withCtx(() => _cache[18] || (_cache[18] = [
            _createTextVNode(" Public API ")
          ])),
          _: 1
        }),
        _createVNode(_component_v_col, {
          cols: "2",
          class: "flex-grow-0 flex-shrink-0"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn_primary, {
              block: "",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openAddApiUserDialog())),
              size: "large"
            }, {
              default: _withCtx(() => _cache[19] || (_cache[19] = [
                _createTextVNode("Ajouter un utilisateur")
              ])),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { class: "flex-grow-0 flex-shrink-1 px-3" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_btn_icon, {
              icon: "$fa-book",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.hrefDocumentation()))
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, {
      "no-gutters": "",
      class: "mt-3"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "6" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, {
              class: "rounded-xl fill-height",
              elevation: "0"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, { cols: "6" }, {
                          default: _withCtx(() => _cache[20] || (_cache[20] = [
                            _createTextVNode(" Utilisateurs ")
                          ])),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "6",
                          class: "d-flex align-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field_filled, {
                              modelValue: _ctx.searchPublicApiUser,
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchPublicApiUser) = $event)),
                              label: "Rechercher",
                              "single-line": "",
                              "hide-details": "",
                              outlined: "",
                              "prepend-inner-icon": "$search",
                              class: "my-n3 mr-n3",
                              density: "compact",
                              clearable: "",
                              "append-inner-icon": "$search",
                              "onClick:clear": _cache[3] || (_cache[3] = ($event: any) => (_ctx.searchPublicApiUser = ''))
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, { style: {"overflow-y":"auto","height":"calc(100vh - 224px)"} }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_list, {
                      nav: "",
                      density: "compact"
                    }, {
                      default: _withCtx(() => [
                        (!_ctx.publicApiUsersFiltred.length)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" Aucun resultat trouvé pour la recherche ")
                            ], 64))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.publicApiUsersFiltred, (user) => {
                          return (_openBlock(), _createElementBlock(_Fragment, {
                            key: user.id
                          }, [
                            _createVNode(_component_v_list_item, {
                              class: "oss-list-item",
                              "two-line": ""
                            }, {
                              append: _withCtx(() => [
                                _createVNode(_component_v_btn_icon, {
                                  icon: "$oss-edit",
                                  onClick: ($event: any) => (_ctx.openEditApiUserDialog(user))
                                }, null, 8, ["onClick"])
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item_title, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(user.firstname) + " " + _toDisplayString(user.lastname), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_list_item_subtitle, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(user.company.shortName || user.company.name), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_v_list_item_subtitle, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.printProfileName(_ctx.getProfileName(user.profile))), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                (user.externalId)
                                  ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, { key: 0 }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString("Identifiant externe : " + user.externalId), 1)
                                      ]),
                                      _: 2
                                    }, 1024))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(_component_v_divider)
                          ], 64))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    (_ctx.addApiUserDialog)
      ? (_openBlock(), _createBlock(_component_oss_dialog, {
          key: 0,
          modelValue: _ctx.addApiUserDialog,
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.addApiUserDialog) = $event)),
          title: "Ajouter un utilisateur",
          "valid-title": _ctx.validTextAPIUserCreation,
          "valid-disabled": !_ctx.isValidAPIUserCreation,
          onValid: _cache[14] || (_cache[14] = ($event: any) => (_ctx.valid())),
          onClose: _cache[15] || (_cache[15] = ($event: any) => (_ctx.addApiUserDialog = false)),
          width: "60vw"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { "no-gutters": "" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "12" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_window, {
                      modelValue: _ctx.step,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.step) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_window_item, { value: "createUser" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, {
                              "no-gutters": "",
                              class: "py-1"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "px-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field_filled, {
                                      modelValue: _ctx.user.firstname,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.user.firstname) = $event)),
                                      label: "Prénom*",
                                      required: "",
                                      outlined: "",
                                      dense: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "px-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field_filled, {
                                      modelValue: _ctx.user.lastname,
                                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.user.lastname) = $event)),
                                      label: "Nom*",
                                      required: "",
                                      outlined: "",
                                      density: "compact"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "px-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field_filled, {
                                      label: "Société*",
                                      required: "",
                                      outlined: "",
                                      readonly: "",
                                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.goToSelectCompany())),
                                      "model-value": _ctx.user.company.name,
                                      density: "compact"
                                    }, null, 8, ["model-value"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "px-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_select_filled, {
                                      modelValue: _ctx.user.profile.id,
                                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.user.profile.id) = $event)),
                                      items: _ctx.availableProfiles,
                                      "item-title": _ctx.getProfileName,
                                      "item-value": "id",
                                      label: "Profil*",
                                      outlined: "",
                                      dense: ""
                                    }, null, 8, ["modelValue", "items", "item-title"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "px-2"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field_filled, {
                                      modelValue: _ctx.user.externalId,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.user.externalId) = $event)),
                                      label: "Identifiant externe",
                                      outlined: "",
                                      dense: ""
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_window_item, { value: "selectCompany" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_CompaniesTable, {
                              showGenericCompany: false,
                              showCustomerCompanies: false,
                              showSupplierCompanies: false,
                              showBobbeeCompanies: true,
                              showExistingCompanies: false,
                              parentCompanyId: _ctx.companyId,
                              onSelectCompany: _ctx.companySelected
                            }, null, 8, ["parentCompanyId", "onSelectCompany"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_window_item, { value: "login" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, {
                              "no-gutters": "",
                              class: "d-flex justify-center pt-2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "6" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field_filled, {
                                      outlined: "",
                                      value: _ctx.login.publicKey,
                                      dense: "",
                                      readonly: "",
                                      label: "Login"
                                    }, {
                                      append: _withCtx(() => [
                                        _createVNode(_component_v_btn_icon, {
                                          icon: "$fa-copy",
                                          color: "primary",
                                          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.copy(_ctx.login.publicKey))),
                                          size: "small"
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["value"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_row, {
                              "no-gutters": "",
                              class: "d-flex justify-center"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "6" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field_filled, {
                                      outlined: "",
                                      value: _ctx.login.privateKey,
                                      dense: "",
                                      readonly: "",
                                      type: _ctx.showPassword ? 'text' : 'password',
                                      label: "Mot de passe"
                                    }, {
                                      append: _withCtx(() => [
                                        _createVNode(_component_v_btn, {
                                          color: "primary",
                                          onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.showPassword = !_ctx.showPassword)),
                                          size: "small"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, {
                                              color: "primary",
                                              size: "small"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(_ctx.showPassword ? "$fa-eye-slash" : "$fa-eye"), 1)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_btn_icon, {
                                          icon: "$fa-copy",
                                          color: "primary",
                                          onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.copy(_ctx.login.privateKey))),
                                          size: "small"
                                        })
                                      ]),
                                      _: 1
                                    }, 8, ["value", "type"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue", "valid-title", "valid-disabled"]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_snackbar, {
      modelValue: _ctx.snackbarTextCopied,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.snackbarTextCopied) = $event)),
      timeout: 2000
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_v_btn, {
          onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.snackbarTextCopied = false)),
          variant: "text"
        }, {
          default: _withCtx(() => _cache[21] || (_cache[21] = [
            _createTextVNode(" Close ")
          ])),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _cache[22] || (_cache[22] = _createTextVNode(" Texte Copié ! "))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}